import React, {useEffect, useState} from "react";
import { Button, Container, Grid, TextField } from "@mui/material";
import Api from "../services/Api";


export const NewSolutionForm = (props) => {
  const {submit} = props
  const [solution, setSolution] = useState({name: "", metrics: [], pauAssignments: []});
  const onNameChange = (e) => {
    setSolution({...solution, name: e.target.value});
  }

  const onSubmit = async () => {
    let success = await submit(solution.name);
    if (success){
      setSolution({name: "", metrics: [], pauAssignments: []});
    }
  }

  return (
    <>
      <Grid container spacing={1}>
        <Grid item>
          <TextField
            variant="outlined"
            label="Name"
            value={solution.name}
            onChange={onNameChange}
          />
        </Grid>
        <Grid item>
          <Button variant="contained" onClick={() => onSubmit()}>
            Submit
          </Button>
        </Grid>
      </Grid>
    </>
  )
}


